import React, { HTMLAttributes } from 'react';
import styled from 'styled-components/macro';
import { useObserver } from 'mobx-react-lite';
import { useMst } from '../models/WithWineState';

const UnstyledCartBadge: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
}) => {
  const state = useMst();
  return useObserver(() => (
    <>
      {(state.session?.getCartQuantityByProductGroup(null) ?? 0) > 0 && (
        <div className={'ww-widget ww-cart-badge ' + className}>
          {state.session?.getCartQuantityByProductGroup(null)}
        </div>
      )}
    </>
  ));
};

const CartBadge = styled(UnstyledCartBadge)`
  background-color: var(--secondary-color);
  border-radius: 50%;
  color: var(--white);
  display: inline-block;
  font-weight: bold;
  min-height: 1.75em;
  min-width: 1.75em;
  text-align: center;
  font-size: 0.65em;
  line-height: 1.75em;
  text-decoration: none !important;
`;

export default CartBadge;
